// extracted by mini-css-extract-plugin
export default {"flag":"CountryFlag_flag__iQ-Sl","icon":"CountryFlag_icon__Ff0eR","label":"CountryFlag_label__0gCme"};